import React from "react";

import { LoadingButton } from "@/components/common/loading-button";
import { useArtistRepository } from "@/pages/artists/hooks/use-artist-repository";

type Props = {
  id: string;
  onUnmerged?: () => void;
};

/**
 * Undo a merge. Only rendered for an artist that carries `mergedInto`.
 *
 * No confirmation dialog: this IS the undo, and the backend refuses to restore an
 * event whose lineup changed since the merge rather than overwriting it.
 */
export const ArtistUnmergeButton = ({ id, onUnmerged }: Props) => {
  const { unmerge } = useArtistRepository();
  const [loading, setLoading] = React.useState(false);

  return (
    <LoadingButton
      type="button"
      variant="outline"
      isLoading={loading}
      disabled={loading}
      onClick={async () => {
        setLoading(true);
        try {
          await unmerge(id);
          onUnmerged?.();
        } catch {
          // The repository already reported it; keep the page as it was.
        } finally {
          setLoading(false);
        }
      }}
    >
      Unmerge
    </LoadingButton>
  );
};
